/**
 * @generated SignedSource<<09381e20269cfd9de530aa9cf7b40b88>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SavingsPlanFrequency = "BIWEEKLY" | "DAILY" | "MONTHLY" | "WEEKLY";
export type SavingsPlanStatus = "ACTIVE" | "CANCELED";
export type SavingsPlansInput = {
  after?: string | null | undefined;
  assetId?: string | null | undefined;
  before?: string | null | undefined;
  first?: number | null | undefined;
  last?: number | null | undefined;
  savingsPlanId?: string | null | undefined;
  status?: SavingsPlanStatus | null | undefined;
};
export type SavingsPlansViewQuery$variables = {
  input?: SavingsPlansInput | null | undefined;
};
export type SavingsPlansViewQuery$data = {
  readonly savingsPlans: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: "SavingsPlan";
        readonly asset: {
          readonly __typename: string;
          readonly id: string;
          readonly logoUrl: string | null | undefined;
          readonly name: string | null | undefined;
          readonly price: PrecisionFloat | null | undefined;
          readonly symbol: string | null | undefined;
        } | null | undefined;
        readonly createdAt: TimeScalar | null | undefined;
        readonly fiat: {
          readonly name: string | null | undefined;
        } | null | undefined;
        readonly fiatAmount: PrecisionFloat | null | undefined;
        readonly frequency: SavingsPlanFrequency | null | undefined;
        readonly id: string;
        readonly name: string | null | undefined;
        readonly nextRecurrence: TimeScalar | null | undefined;
        readonly notificationDate: TimeScalar | null | undefined;
        readonly status: SavingsPlanStatus | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
    readonly pageInfo: {
      readonly endCursor: string | null | undefined;
      readonly hasNextPage: boolean;
    } | null | undefined;
    readonly totalCount: number | null | undefined;
  } | null | undefined;
};
export type SavingsPlansViewQuery = {
  response: SavingsPlansViewQuery$data;
  variables: SavingsPlansViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nextRecurrence",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notificationDate",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "frequency",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fiatAmount",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "asset",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "logoUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "price",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "symbol",
      "storageKey": null
    },
    (v3/*: any*/)
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SavingsPlansViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SavingsPlansConnection",
        "kind": "LinkedField",
        "name": "savingsPlans",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SavingsPlansEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SavingsPlan",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Fiat",
                    "kind": "LinkedField",
                    "name": "fiat",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v13/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SavingsPlansViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SavingsPlansConnection",
        "kind": "LinkedField",
        "name": "savingsPlans",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SavingsPlansEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SavingsPlan",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Fiat",
                    "kind": "LinkedField",
                    "name": "fiat",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v13/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ff73b29edf363bb5d7cfb44e630467b4",
    "id": null,
    "metadata": {},
    "name": "SavingsPlansViewQuery",
    "operationKind": "query",
    "text": "query SavingsPlansViewQuery(\n  $input: SavingsPlansInput\n) {\n  savingsPlans(input: $input) {\n    totalCount\n    edges {\n      node {\n        __typename\n        id\n        name\n        status\n        createdAt\n        nextRecurrence\n        notificationDate\n        frequency\n        fiatAmount\n        asset {\n          id\n          name\n          logoUrl\n          price\n          symbol\n          __typename\n        }\n        fiat {\n          name\n          id\n        }\n      }\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4f176806ae05961cad088dc2a468012d";

export default node;
